var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"menu-item-btn",attrs:{"small":"","text":""},on:{"click":_vm.handleClick}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"18"}},[_vm._v("mdi-content-duplicate")]),_c('span',[_vm._v("Duplicar colaboração")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }